import React, { useState, useContext, useEffect } from 'react';
import { FaGoogle, FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { LoginContext } from '../../Contexts/LoginContext';
import axios from 'axios';
import { showToast } from '../../Components/utils/ShowToast';
import Loader from '../../Components/utils/Loader';
import Logo from '../../images/pngs/Logo.png';
import SEO from '../../Components/utils/SEO';

const SignInPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login, fetchUserData } = useContext(LoginContext);
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const incompleteUser = urlParams.get('incompleteUser');

    if (token) {
      window.history.replaceState({}, document.title, window.location.pathname);
      login(token);
      if (incompleteUser === 'true') {
        navigate('/completeProfile');
      } else {
        showToast("Login Successful!", "success");
        navigate('/');
      }
    }
  }, [login, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/auth/login`, formData);
      if (response.data.success) {
        const { token } = response.data;
        login(token);
        // Wait for user data to be fetched and check profile completeness
        const userData = await fetchUserData();
        if (userData) {
          const incomplete = !userData.phone || !userData.languages || !userData.currency || !userData.buyerAddress?.country?.name;
          if (incomplete) {
            showToast("Please complete your profile!", "info");
            navigate('/completeProfile');
          } else {
            showToast("Login Successful!", "success");
            navigate('/');
          }
        } else {
          showToast("Login Successful!", "success");
          navigate('/');
        }
      }
    } catch (error) {
      console.error(error);
      showToast(error.response?.data?.error || "Login Failed", "error");
    }
    finally {
      setLoading(false);
    }
  };

  const handleSocialLogin = (provider) => {
    window.location.href = `${process.env.REACT_APP_Backend_Host_Name}/api/v1/auth/login/${provider}`;
  };

  return (
    <div className="signInContainer">
      <SEO title="Sign in" description="Sign in to your Chocowi account." noIndex noFollow />
      <Link to="/" className="chocowiLogoDiv">
        <img src={Logo} alt="Chocowi Logo" className="chocowiLogo" />
      </Link>
      <form className="signInContent" onSubmit={handleSubmit}>
        <div className="signInHeader">
          <h2 className="signInTitle">Welcome Back</h2>
          <p className="signInSubtitle">Please enter your details to sign in.</p>
        </div>
        <div className="inputContainer">
          <label htmlFor="email" className="label">Enter Email</label>
          <input
            type="email"
            id="email"
            name="email"
            className="inputField"
            value={formData.email}
            onChange={handleInputChange}
            required
            placeholder="Enter your email"
            disabled={loading}
          />
        </div>
        <div className="inputContainer">
          <div className="passwordHeader">
            <label htmlFor="password" className="label">Password</label>
            <Link to="/resetPasswordRequest" className='forgotPasswordBtn'>Forgot Password?</Link>
          </div>

          <div className="passwordInputWrapper">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              className="inputField passwordField"
              value={formData.password}
              onChange={handleInputChange}
              required
              placeholder="Enter your password"
              disabled={loading}
            />
            <div
              className='hidePasswordBtn'
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </div>
          </div>
        </div>
        <button type="submit" className="primaryBtn" disabled={loading} style={loading ? { padding: "16px 0px" } : { cursor: "pointer" }}>{loading ? <Loader type="miniPlus" /> : "Continue"}</button>
        <div className="separator">OR</div>
        <div className="socialLoginContainer">
          <button
            type="button"
            className="socialLogin googleLogin"
            onClick={() => handleSocialLogin('google')}
            disabled={loading}
          >
            <FaGoogle className="icon" />
            Continue with Google
          </button>
        </div>
        <div className="signInFooter">
          <p>Don't have an account yet? <Link to="/signup" className="signin">Sign Up</Link> </p>
        </div>
      </form>
    </div>
  );
};

export default SignInPage;